var React = require('react');

function GFWCross (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0db0e7;fill-rule:evenodd;}")),React.createElement("polygon",{"id":"Mask","className":"cls-1","points":"179.46 116.44 232.87 63.03 169.84 0 116.44 53.41 63.03 0 0 63.03 53.41 116.44 0 169.84 63.03 232.87 116.44 179.46 169.84 232.87 232.87 169.84 179.46 116.44","key":1})]);
}

GFWCross.defaultProps = {"width":"232px","height":"232px","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 232.87 232.87"};

module.exports = GFWCross;

GFWCross.default = GFWCross;
